const s="wishlist",t=3600;export{t as DEFAULT_EXPIRE_TIME_1HR,s as WISHLIST_STORAGE_KEY};
